module.exports = __webpack_public_path__ + "static/media/S3N2-4.2987e930.svg";